<div class="nf-page" [class.nf-page--full]="fullViewport">
  <div class="nf-card">
    <div class="nf-card__icon" aria-hidden="true">
      <img
        *ngIf="fullViewport; else defaultIcon"
        src="assets/iconLogo.png"
        alt=""
        class="nf-card__logo"
      />
      <ng-template #defaultIcon>
        <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
          <circle cx="11" cy="11" r="8" />
          <path d="m21 21-4.3-4.3" stroke-linecap="round" />
          <path d="M8 11h6" stroke-linecap="round" />
        </svg>
      </ng-template>
    </div>
    <h1 class="nf-card__title">{{ titleKey | translate }}</h1>
    <p class="nf-card__hint">{{ hintKey | translate }}</p>
    <button type="button" class="nf-card__btn" (click)="back.emit()">
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
        <path d="m15 18-6-6 6-6" stroke-linecap="round" stroke-linejoin="round" />
      </svg>
      {{ backLabelKey | translate }}
    </button>
  </div>
</div>
